import NotificationBell from 'ui-component/notifications/NotificationBell';

export default function CandidateNotifications() {
    return <NotificationBell allowedPrincipalTypes={['candidate']} />;
}
